"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocalJSON = void 0;
const getLocalJSON = (path) => {
    const store = {
        create: (key, value) => {
            localStorage.setItem(`${path}/${key}`, JSON.stringify(value));
        },
        read: (key) => {
            const value = localStorage.getItem(`${path}/${key}`);
            try {
                return value ? JSON.parse(value) : undefined;
            }
            catch (_error) {
                return undefined;
            }
        },
        update: (key, value) => store.create(key, value),
        delete: (key) => {
            localStorage.removeItem(`${path}/${key}`);
        },
        list: () => {
            const keys = Object.keys(localStorage);
            return keys
                .map((key) => {
                if (key.indexOf(`${path}/`) === 0) {
                    return store.read(key.replace(`${path}/`, ''));
                }
            })
                .filter((v) => typeof v !== 'undefined');
        },
    };
    return store;
};
exports.getLocalJSON = getLocalJSON;
